// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOcrAmountOptionDto
 */
export interface IOcrAmountOptionDto {
    /**
     * 
     * @type {number}
     * @memberof IOcrAmountOptionDto
     */
    amount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IOcrAmountOptionDto
     */
    is_suggested?: boolean;
}

/**
 * Check if a given object implements the IOcrAmountOptionDto interface.
 */
export function instanceOfIOcrAmountOptionDto(value: object): value is IOcrAmountOptionDto {
    return true;
}

export function IOcrAmountOptionDtoFromJSON(json: any): IOcrAmountOptionDto {
    return IOcrAmountOptionDtoFromJSONTyped(json, false);
}

export function IOcrAmountOptionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOcrAmountOptionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'is_suggested': json['is_suggested'] == null ? undefined : json['is_suggested'],
    };
}

export function IOcrAmountOptionDtoToJSON(json: any): IOcrAmountOptionDto {
    return IOcrAmountOptionDtoToJSONTyped(json, false);
}

export function IOcrAmountOptionDtoToJSONTyped(value?: IOcrAmountOptionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'is_suggested': value['is_suggested'],
    };
}

